export { DMS_MODULE } from '../constants';
export const NAME = 'CommunicationEventConfiguration';
export const MODULE_API = 'Ciselniky';
